import { HashLink, NavHashLink } from 'react-router-hash-link';
import styles from './NavBar.module.css';

export default function NavBar(props) {
    const { hash } = props;
    // const isActive = (iHash) => hash === iHash;
    const isActive = (iHash) => false;

    return (
        <div>
            <ul id={styles.navbar}>
                {/* <li><NavHashLink style={{ textDecoration:'none' }} smooth to="#"><div className={isActive("") ? styles.active : styles.navlink}>Home</div></NavHashLink></li> */}
                <li><NavHashLink style={{ textDecoration:'none' }} smooth to="#about"><div className={isActive("#about") ? styles.active : styles.navlink}>About</div></NavHashLink></li>
                {/* <li><div className={styles.navlink}>Skills</div></li> */}
                <li><NavHashLink style={{ textDecoration:'none' }} smooth to="#experience"><div className={isActive("#experience") ? styles.active : styles.navlink}>Experience</div></NavHashLink></li>
                <li><NavHashLink style={{ textDecoration:'none' }} smooth to="#projects"><div className={isActive("#projects") ? styles.active : styles.navlink}>Projects</div></NavHashLink></li>
                <li><NavHashLink style={{ textDecoration:'none' }} smooth to="#contact"><div className={isActive("#contact") ? styles.active : styles.navlink}>Contact</div></NavHashLink></li>
            </ul>
        </div>
    );
}